import { FormRenderProps } from 'react-final-form';

import DateField from 'components/formInputs/DateField';
import SelectField from 'components/formInputs/SelectField';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import { InitialValues } from 'forms/types';
import { Gender } from 'types/graph';

import { STATES } from './constants';
import { BasicsFormValues } from './types';

const BasicsForm: React.FC<FormRenderProps<BasicsFormValues, InitialValues<BasicsFormValues>>> = ({
  handleSubmit,
  invalid,
  submitting,
}) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <ToggleField
      groupLabel="Gender"
      name="gender"
      choices={[
        { label: 'Male', value: Gender.Male },
        { label: 'Female', value: Gender.Female },
      ]}
    />
    <DateField label="Date of birth" name="dateOfBirth" includeDay />
    <SelectField label="State" name="stateId" options={STATES} />
  </FormWrapper>
);

export default BasicsForm;
